import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  BarChart3,
  CreditCard,
  Bell,
  FileText,
  Settings,
} from 'lucide-react';

interface MenuItem {
  name: string;
  path: string;
  icon: React.ReactNode;
}

const menuItems: MenuItem[] = [
  {
    name: 'Dashboard',
    path: '/admin',
    icon: <LayoutDashboard className="w-5 h-5" />,
  },
  {
    name: 'Usuários',
    path: '/admin/users',
    icon: <Users className="w-5 h-5" />,
  },
  {
    name: 'Analytics',
    path: '/admin/analytics',
    icon: <BarChart3 className="w-5 h-5" />,
  },
  {
    name: 'Assinaturas',
    path: '/admin/subscriptions',
    icon: <CreditCard className="w-5 h-5" />,
  },
  {
    name: 'Comunicação',
    path: '/admin/communication',
    icon: <Bell className="w-5 h-5" />,
  },
  {
    name: 'Logs',
    path: '/admin/logs',
    icon: <FileText className="w-5 h-5" />,
  },
  {
    name: 'Configurações',
    path: '/admin/settings',
    icon: <Settings className="w-5 h-5" />,
  },
];

const AdminSidebar: React.FC = () => {
  return (
    <aside className="w-64 bg-slate-900 border-r border-slate-700 min-h-screen">
      <nav className="p-4 space-y-1">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/admin'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-amber-500 text-white'
                  : 'text-slate-300 hover:bg-slate-800 hover:text-white'
              }`
            }
          >
            {item.icon}
            <span className="font-medium">{item.name}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default AdminSidebar;
